import React from 'react'
import classes from './AnswerItem.css'

const AnswerItem = props => {
    const clc = [classes.AnswerItem]
    
    if(props.state) {
        clc.push(classes[props.state])
    }

    return (
        <li 
        className={clc.join(' ')}
        onClick={()=> props.onAnswerClick(props.answer.id)}
        >  
        { props.answer.text}
        </li>
    )
}

export default AnswerItem